export default {
  "name": "NCCheckbox",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCCheckbox",
  "label": "多选",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "type": {
        "title": "类型",
        "description": "类型",
        "type": "string"
      },
      "checked": {
        "title": "选中",
        "description": "选中",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}